import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for all Google Sheets integration pages.
 * Renders an <Outlet /> for child routes (list, create, detail).
 */
export const Route = createFileRoute('/_dashboard/org/$orgId/integrations/google-sheets')({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
